import { useState } from 'react';
import { Link } from 'react-router-dom';
import { hotRankingComics } from '@/mocks/home';

export default function HotRankingSection() {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 text-center mb-12">
          🔥 热门排行
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {hotRankingComics.map((comic, index) => (
            <Link
              key={comic.id}
              to="/category/all"
              className={`group relative rounded-xl overflow-hidden cursor-pointer transition-all duration-500 ${
                hoveredId && hoveredId !== comic.id ? 'md:opacity-60' : ''
              }`}
              onMouseEnter={() => setHoveredId(comic.id)}
              onMouseLeave={() => setHoveredId(null)}
              style={{ aspectRatio: '3/4' }}
            >
              <img
                src={comic.coverImage}
                alt={comic.title}
                title={`${comic.title} - 热门韩漫推荐`}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent"></div>

              <div className="absolute top-3 left-3 bg-primary-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                TOP {index + 1}
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-white text-xl md:text-2xl font-heading mb-1">{comic.title}</h3>
                <p className="text-white/70 text-xs md:text-sm mb-2">{comic.author} · {comic.latestChapter}</p>
                <div className="flex items-center gap-3 text-white/60 text-xs">
                  <span className="flex items-center gap-1">
                    <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-star-fill text-yellow-400 text-xs"></i></span>
                    {comic.rating}
                  </span>
                  <span>{comic.views}</span>
                </div>

                <div className={`overflow-hidden transition-all duration-500 ${hoveredId === comic.id ? 'max-h-24 opacity-100 mt-3' : 'max-h-0 opacity-0'}`}>
                  <p className="text-white/70 text-xs leading-relaxed">{comic.description}</p>
                  {comic.tags.map((tag) => (
                    <span key={tag} className="inline-block text-xs text-white/60 bg-white/10 px-2 py-0.5 rounded-full mr-1.5 mt-2">{tag}</span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-primary-600 hover:text-primary-700 rounded-full border border-primary-300 hover:border-primary-400 cursor-pointer transition-colors whitespace-nowrap"
          >
            查看全部热门 <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </Link>
        </div>
      </div>
    </section>
  );
}